
    var riot = require('riot')
    //src: starling/src/tags/comments/comment.html
riot.tag2('comment',
  '<img class="avatar avatar--tall comment_user_avatar" riot-src="{commentsUI.getOwnerInfo(instance.id).avatar_url}" alt="{commentsUI.getOwnerInfo(instance.id).display_name}"> <div class="comment_content"> <div class="comment_actions"> <button if="{commentsUI.canReply(instance.id)}" class="Button Button--Light Button--{size === \'small\' ? \'Link\' : \'Plain\'} Button--Icon Button--XSmall" onclick="{toggleReply}" data-tooltip="Reply" onmouseenter="{summonToolTip}" onmouseleave="{hideToolTip}"> <svg class="Button__Icon"> <use xlink:href="#reply-icon"></use> </svg> </button> <button if="{commentsUI.canReply(instance.id)}" ref="reaction" class="Button Button--Light Button--{type === \'sidebar\' ? \'Plain\' : \'Link\'} Button--Icon Button--XSmall" onclick="{toggleReactionMenu}" data-tooltip="Add reaction" data-tooltip-alignment="{type === \'sidebar\' ? \'end\' : \'center\'}" onmouseenter="{summonToolTip}" onmouseleave="{hideToolTip}"> <svg class="Button__Icon"> <use xlink:href="#insert-emoticon-icon"></use> </svg> </button> <button if="{showMenu()}" ref="menu" class="Button Button--Light Button--{type === \'sidebar\' ? \'Plain\' : \'Link\'} Button--Icon Button--XSmall" onclick="{toggleMenu}" data-tooltip="More options" data-tooltip-alignment="{type === \'sidebar\' ? \'end\' : \'center\'}" onmouseenter="{summonToolTip}" onmouseleave="{hideToolTip}"> <svg class="Button__Icon"> <use xlink:href="#more-vert-icon"></use> </svg> </button> </div> <div class="comment_info"> <span class="comment_user_name">{commentsUI.getOwnerInfo(instance.id).display_name}</span> <a class="comment_time" href="{getDirectCommentUrl()}" data-tooltip="{prettyTimestamp()}" onclick="{handleCommentLinkClick}" onmouseenter="{summonToolTip}" onmouseleave="{hideToolTip}"> {getCommentTime()} </a> </div> <p ref="text" class=" comment_text focusable {commentsUI.isDeleted(instance.id) && \'comment_text--deleted\'} {editing && \'comment_text--editing\'} " onpaste="{handlePaste}">{commentsUI.commentText(instance.id)}</p> <div if="{editing}" class="comment_buttons"> <button class="Button Button--Small Button--Primary" onclick="{finishEdit}">Save</button> <button class="Button Button--Small Button--Link" onclick="{cancelEdit}">Cancel</button> </div> <div if="{commentsUI.getUpvoteCount(instance.id) || commentsUI.getDownvoteCount(instance.id)}" class="comment_reactions"> <button if="{commentsUI.getUpvoteCount(instance.id)}" ref="upvoteButton" class="Button Button--Light Button--Plain Button--XSmall {commentsUI.wasUpvoted(instance.id) && \'Button--Active\'}" data-tooltip="{commentsUI.getUpvoteNames(instance.id).join(\', \')}" data-tooltip-position="below" onmouseenter="{summonToolTip}" onmouseleave="{hideToolTip}" onclick="{commentsUI.vote.bind(commentsUI, instance.id, 1)}"> <svg class="Button__Icon"> <use xlink:href="#thumbs-up-icon"></use> </svg> <span class="Button__Label"> {commentsUI.getUpvoteCount(instance.id)} </span> </button> <button if="{commentsUI.getDownvoteCount(instance.id)}" ref="downvoteButton" class="Button Button--Light Button--Plain Button--XSmall {commentsUI.wasDownvoted(instance.id) && \'Button--Active\'}" data-tooltip="{commentsUI.getDownvoteNames(instance.id).join(\', \')}" data-tooltip-position="below" onmouseenter="{summonToolTip}" onmouseleave="{hideToolTip}" onclick="{commentsUI.vote.bind(commentsUI, instance.id, -1)}"> <svg class="Button__Icon"> <use xlink:href="#thumbs-down-icon"></use> </svg> <span class="Button__Label"> {commentsUI.getDownvoteCount(instance.id)} </span> </button> </div> <span if="{instance.isResolved()}" class="comment_resolved"> <svg class="comment_resolved_icon"> <use xlink:href="#check-icon"></use> </svg> Resolved </span> <comment-replies if="{commentsUI.getReplies(instance.id).length}" canvas="{canvas}" size="{size}" type="{type}"></comment-replies> <new-comment-input target="reply" canvas="{canvas}" parentid="{instance.id}" commenttag="{this}" type="{type}"></new-comment-input> </div>',
  '',
  'class="comment {commentsUI.isReply(instance.id) && \'comment--reply\'} {type && \'comment--\' + type} {size && \'comment--\' + size} " onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" onclick="{handleClick}"', function(opts) {
'use strict';

var _this = this;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _appUi = require('lib/app-ui');

var _commentsUi = require('lib/comments-ui');

var _util = require('lib/util');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkifyHtml = require('linkifyjs/html');

var _opts = opts,
    canvas = _opts.canvas,
    instance = _opts.instance,
    type = _opts.type,
    size = _opts.size;

Object.assign(this, { canvas: canvas, instance: instance, type: type, size: size });

if (type === 'sidebar') {
  canvas.commentTagsInSidebar[instance.id] = this;
} else {
  canvas.commentTags[instance.id] = this;
}

_moment2.default.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'now',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mo',
    MM: '%dmo',
    y: '1y',
    yy: '%dy'
  }
});

this.isTopLevel = function () {
  return !instance.getParentId();
};

this.getCommentTime = function () {
  return (0, _moment2.default)(instance.createdTime).fromNow(true);
};

this.isMapComment = function () {
  return instance.getTarget() === 'map';
};

this.isSelectionComment = function () {
  return instance.getTarget() === 'selection';
};

this.onMoveStart = function (e) {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  _commentsUi.commentsUI.resetDragData();
  _commentsUi.commentsUI.setPrevCommentPosition(instance);
};

this.onMove = function (_ref) {
  var dx = _ref.dx,
      dy = _ref.dy;

  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;

  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  var instance = _this.instance;

  _this.dragging = true;
  dx = dx / scale;
  dy = dy / scale;

  _commentsUi.commentsUI.applyMove({ dx: dx, dy: dy, draggingComment: instance });
  _this.update();
};

this.onMoveEnd = function (e) {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  setTimeout(function () {
    // don't trigger a click
    delete _this.dragging;
  }, 400);
  e.stopPropagation();
  var operationMessages = [];
  var message = _commentsUi.commentsUI.getCommentPositionOperationMessage(instance);
  operationMessages.push(message);

  canvas.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.log('Comment move batchOperation failure: ' + err);
    }
  });

  _commentsUi.commentsUI.resetDragData();
};

this.startEdit = function (e) {
  _this.refs.text.setAttribute("contenteditable", true);
  _this.refs.text.focus();
  _this.prevCommentText = _this.refs.text.innerText.trim();
  _this.editing = true;
  _this.update();
};

this.finishEdit = function (e) {
  var text = _this.refs.text.innerText.trim();
  _this.refs.text.setAttribute("contenteditable", false);

  var comment = _this.getInstance();
  comment.setText(text);
  canvas.operation.editComment({
    uuid: comment.id,
    commentText: text,
    prevCommentText: _this.prevCommentText
  });

  _this.editing = false;

  _commentsUi.commentsUI.freshenComment(comment);
};

this.cancelEdit = function (e) {
  _this.refs.text.innerText = _this.prevCommentText;
  _this.refs.text.setAttribute('contenteditable', false);
  _this.editing = false;
  _this.update();
};

this.toggleReply = function (e) {
  e.stopPropagation();
  var parent = instance.getParent();

  if (parent) {
    var targetUser = _commentsUi.commentsUI.getUserInfo(instance.userId);
    var targetTag = void 0;
    if (type === 'sidebar') {
      targetTag = canvas.commentTagsInSidebar[parent.id];
    } else {
      targetTag = canvas.commentTags[parent.id];
    }

    if (targetTag) {
      return targetTag.newCommentInput.toggle({
        targetUser: targetUser,
        replyTo: instance.id
      });
    }
  }

  _this.newCommentInput.toggle({
    replyTo: instance.id
  });

  _eventTracking2.default.track({
    category: 'Comment-Action',
    action: 'Comment-Reply',
    label: 'Start-Comment-Reply'
  });
};

this.deleteComment = function (e) {
  _commentsUi.commentsUI.deleteComment(_this);
};

this.moveEnabled = function () {
  return instance.getTarget() === 'map' || instance.getTarget() === 'selection';
};

this.updateReplies = function () {
  _this.update();

  if (_this.tags['new-comment-input']) {
    _this.tags['new-comment-input'].update();
  }
};

this.isShownComment = function () {
  if (_this.type === 'sidebar') return true;
  if (instance.getTarget() === 'reply') return true;
  if (instance.getTarget() === 'node') return true;

  return _commentsUi.commentsUI.isShownComment(instance.id);
};

this.isDraggableComment = function () {
  if (_this.type === 'sidebar') return false;
  if (_this.isMapComment() || _this.isSelectionComment()) return true;

  return false;
};

this.toggleComment = function () {
  if (_this.dragging) return;

  if (_this.isShownComment()) {
    _this.dismiss();
  } else {
    _this.show();
  }
};

this.show = function () {
  _commentsUi.commentsUI.showComment(instance.id);
  _this.update();
};

this.dismiss = function () {
  _commentsUi.commentsUI.hideComment(instance.id);
  _this.update();
};

this.getTotalReplyAncestorCount = function () {
  return _commentsUi.commentsUI.getTotalReplyAncestorCount(instance.id);
};

/*
  hide edit control unless you're owner of the commment
  (do the real security check on the back end)
*/
this.showMenu = function () {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return false;
  return _commentsUi.commentsUI.isOwner(instance.id) || instance && !instance.parentId || _appUi.appUI.isMapOwner();
};

this.getInstance = function () {
  return canvas.store.getComment(instance.id);
};

this.on('mount', function () {
  _this.updateTextDisplay();

  $(_this.refs.text).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.toggleMenu = function (event) {
  var commentMenuTag = canvas.commentMenuTag,
      commentReactionMenuTag = canvas.commentReactionMenuTag;

  if (event && event.stopPropagation) event.stopPropagation();

  commentReactionMenuTag.hide();

  commentMenuTag.toggle({
    comment: instance,
    referenceEl: _this.refs.menu,
    position: _this.type === 'sidebar' ? 'right' : null
  });
};

this.toggleReactionMenu = function (event) {
  var commentMenuTag = canvas.commentMenuTag,
      commentReactionMenuTag = canvas.commentReactionMenuTag;

  if (event && event.stopPropagation) event.stopPropagation();

  commentMenuTag.hide();

  commentReactionMenuTag.toggle({
    comment: instance,
    referenceEl: _this.refs.reaction
  });

  _eventTracking2.default.track({
    category: 'Comment-Action',
    action: 'Toggle-Reaction-Menu',
    label: commentReactionMenuTag.summoned ? 'Open-Reaction-Menu' : 'Close-Reaction-Menu'
  });
};

this.handleCommentLinkClick = function (e) {
  e.preventDefault();
  e.stopPropagation();
  var url = _this.getDirectCommentUrl(instance.id);
  window.history.pushState({}, '', url);
};

this.getDirectCommentUrl = function () {
  return _commentsUi.commentsUI.getDirectCommentUrl(instance.id);
};

this.handleMouseEnter = function (e) {
  if (_this.type !== 'sidebar') return;
  _commentsUi.commentsUI.highlightCommentContent(instance.id);
};

this.handleMouseLeave = function (e) {
  if (_this.type !== 'sidebar') return;
  _commentsUi.commentsUI.unhighlightCommentContent();
};

this.handleClick = function (e) {
  if (_this.type !== 'sidebar') return;
  _commentsUi.commentsUI.panToComment(instance.id);
};

this.prettyTimestamp = function () {
  return (0, _moment2.default)(instance.createdTime).format('llll');
};

this.summonToolTip = function (_ref2) {
  var target = _ref2.target;
  var dataset = target.dataset;
  var tooltip = dataset.tooltip,
      tooltipPosition = dataset.tooltipPosition,
      tooltipAlignment = dataset.tooltipAlignment;

  canvas.floatingTooltip.summon({
    referenceEl: target,
    tip: tooltip,
    position: tooltipPosition,
    alignment: tooltipAlignment
  });
};

this.hideToolTip = function () {
  canvas.floatingTooltip.hide();
};

this.updateTextDisplay = function () {
  var text = _commentsUi.commentsUI.commentText(instance.id);
  if (!_this.refs || !_this.refs.text) return;
  if (text === undefined || text === null) return;

  var content = (0, _util.convertNewlines)((0, _escapeHtml2.default)(text)).trim();
  if (!_this.editing) {
    content = linkifyHtml(content);
  }

  if (_this.refs && _this.refs.text) {
    _this.refs.text.innerHTML = content;
  }
};

this.handlePaste = function (e) {
  e.preventDefault();
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  var text = (0, _util.convertNewlines)((0, _escapeHtml2.default)(e.clipboardData.getData("text/plain")));
  document.execCommand("insertHTML", false, text);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comment')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comment.html
// module id = 777
// module chunks = 0